var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    stroke: "#112348"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.269 35.1814C19.731 35.1814 18.1963 34.706 16.899 33.7741L14.1319 31.7881C13.5344 31.3609 13.1316 30.696 13.0275 29.9674C12.9284 29.2818 13.0991 28.6169 13.5088 28.0898C14.2002 27.1993 15.361 26.8582 16.4005 27.2424L20.7296 28.846L40.27 19.3464C41.9394 18.5678 43.9196 19.3068 44.6895 20.9879C45.4593 22.6674 44.7407 24.681 43.0848 25.4785L24.4867 34.4476C23.4659 34.9385 22.3666 35.1814 21.2673 35.1814H21.269ZM24.485 24.0351L31.7109 20.5229L23.9115 15.6619C22.9333 14.9281 21.636 14.7938 20.5213 15.3123L19.48 15.8066C18.8689 16.096 18.4473 16.6713 18.3517 17.3465C18.2561 18.0218 18.5002 18.6935 19.0055 19.1448L24.4833 24.0368L24.485 24.0351Z",
    fill: "#D69B29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41.9097C13 41.3068 13.4848 40.8193 14.0806 40.8193H43.9177C44.5152 40.8193 44.9983 41.3085 44.9983 41.9097C44.9983 42.5108 44.5135 43 43.9177 43H14.0806C13.4831 43 13 42.5108 13 41.9097Z",
    fill: "#D69B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.2277b793db1f96b1b7627c51037e1840.svg";
export { ForwardRef as ReactComponent };